import { createSelector } from 'reselect';

import { initialState, ScorecardRequiredModalState } from './reducer';

const selectScorecardRequiredModal = (state: {
  scorecardRequiredModal?: ScorecardRequiredModalState;
}): ScorecardRequiredModalState => state.scorecardRequiredModal || initialState;

export const makeSelectScorecardRequirement = () =>
  createSelector(
    selectScorecardRequiredModal,
    substate => substate.requirement,
  );
